/**
 * StarRating — cinco estrelas via <use>, não cinco <svg> inteiros.
 *
 * O ícone Star do lucide-react serializa 642 bytes por estrela. Na home isso
 * eram 65 cópias do MESMO path (13 depoimentos × 5 + o hero) = 41,7 KB de
 * 225 KB do HTML pré-renderizado — 18% do arquivo em markup repetido, o que
 * derrubava a razão texto/HTML para 9,6%.
 *
 * O path fica uma vez só, como <symbol id="i-star"> no index.html (fora do
 * #root, então o React nunca o toca e não há divergência de hidratação).
 * Aqui sobra a casca do <svg>: ~110 bytes por estrela.
 */
import React from 'react';

interface StarRatingProps {
  /** Classes do container. */
  className?: string;
  /** Rótulo acessível; o grupo é aria-hidden quando não informado. */
  label?: string;
}

const StarRating: React.FC<StarRatingProps> = ({ className = 'flex space-x-1', label }) => (
  <div
    className={className}
    {...(label ? { role: 'img', 'aria-label': label } : { 'aria-hidden': true })}
  >
    {[1, 2, 3, 4, 5].map((star) => (
      <svg key={star} className="star-ico" viewBox="0 0 24 24">
        <use href="#i-star" />
      </svg>
    ))}
  </div>
);

export default StarRating;
